import { OPERATION_STATUS_NAME, OPERATION_AD_TYPE_NAME } from '../constants'
export const formatOperationList = (data = []) => {
    const res = data.map(item => {
        item.status = OPERATION_STATUS_NAME[item.actionType] || item.status
        item.type = OPERATION_AD_TYPE_NAME[item.adType]
        return item
    })
    return res
}
